export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_10.411b27e1.jpg";